module.exports = "<uch></uch>\r\n<head-title params='title:\"应用列表 / 授权列表\"'></head-title>\r\n<auth-list></auth-list>\r\n\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/component/appConfig/appConfigIndex.html
// module id = 191
// module chunks = 0